module.exports = __webpack_public_path__ + "static/kvm_6.f6b5a9c4.jpg";